import React from "react";

const SingleSelect = ({label, required = true, selectedField,setterFunction,list}) => {
  return (
    <>
      <label
        htmlFor="state"
        className="block mb-2 text-sm font-medium text-gray-900 "
      >
        {label}
        {required && <span className="text-red-500 fixed h-3">*</span>}
      </label>
      <select
        name="installerId"
        onChange={(e) => setterFunction(e.target.value)}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:focus:ring-blue-500 dark:focus:border-blue-500"
      >
        {selectedField === "" ? (
          <option>Select {label}</option>
        ) : (
          <option disabled>Select {label}</option>
        )}
        {list?.map(({ name, _id }, index) => (
          <option key={index} value={_id}>
            {name}
          </option>
        ))}
      </select>
    </>
  );
};

export default SingleSelect;
